module.exports = __webpack_public_path__ + "static/img_9960_dpp_optimized-0daf7d6a02b30d354934c1255a27586a.jpg";